
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 26 19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#F9CE62","d":"M14.554 16.404c0 1.032-.956 1.869-2.136 1.869s-2.136-.837-2.136-1.869.957-1.869 2.136-1.869 2.136.837 2.136 1.869M23.098 15.87c0-1.367-.262-2.721-.772-3.985a10.4 10.4 0 0 0-2.2-3.378l-4.794 4.92c.313.321.561.702.73 1.121.17.42.256.868.256 1.322z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"1.382","d":"m21.728 12.493-7.25 2.575"}}),_c('circle',{attrs:{"cx":"2.136","cy":"2.136","r":"1.445","stroke":"#234652","stroke-width":"1.382","transform":"matrix(-1 0 0 1 15.012 13.723)"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"1.382","d":"M24.548 15.603c0-6.489-5.26-11.749-11.748-11.749S1.052 9.114 1.052 15.603"}})])
          )
        }
      }
    